$(document).ready(function() {
  // イベントデリゲーションを使用
  $(document).on('click', 'a.smooth', function() {
    var headerHeight = getComputedStyle(document.documentElement)
      .getPropertyValue('--header-height')
      .replace('px', '')
      .trim();
    var adjust = -parseInt(headerHeight, 10) || 0;
    var speed = 400;
    var href = $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position = target.offset().top + adjust;
    $('body,html').animate({
      scrollTop: position
    }, speed, 'swing');
    return false;
  });
});

$(document).ready(function() {
  let accordionTtl = $('.js-accordion-ttl');
  let speed = 100;

  accordionTtl.on('click', function(e) {
    e.preventDefault(); // デフォルト動作を防止

    if ($(this).closest('.js-accordion').attr('open')) {
      $(this).next().slideUp(speed, function() {
        $(this).closest('.js-accordion').removeAttr('open');
      });
    } else {
      $(this).closest('.js-accordion').attr('open', 'true');
      $(this).next().hide().slideDown(speed);
    }
  });
});
